import { PATHS_WITHOUT_TAB_BAR } from './consts'

/**
 * 하단 탭바 노출 여부를 반환
 * 명시한 곳 외에는 기본적으로 탭바를 노출한다.
 * 탭바 정책은 'CTA 유도 페이지'인 경우에 미노출하는 것으로 정의한다.
 * @param pathname
 */
export const isTabBarVisible = (pathname: string): boolean => {
  return !PATHS_WITHOUT_TAB_BAR.some((path) => pathname.startsWith(path))
}
